import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface PosHeaderActionsConfig {
  show: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PosHeaderActionsService {
  private readonly configSubject =
    new BehaviorSubject<PosHeaderActionsConfig | null>(null);
  private readonly clickSubject = new Subject<string>();

  readonly config$ = this.configSubject.asObservable();
  readonly click$ = this.clickSubject.asObservable();

  setConfig(config: PosHeaderActionsConfig): void {
    this.configSubject.next(config);
  }

  clearConfig(): void {
    this.configSubject.next(null);
  }

  emitClick(actionId: string): void {
    this.clickSubject.next(actionId);
  }
}

